import { useEffect } from 'react';

export const useDisableNumberInputScroll = () => {
    // Use the useEffect hook to manage side effects
    useEffect(() => {
        // Define a function to prevent the default scroll behavior
        const stopChange = (e) => {
            e.stopPropagation();
        };

        // Find all number input elements in the document
        const numberInputs = document.querySelectorAll('input[type="number"]');
        const spinButtonInputs = document.querySelectorAll('input[role="spinbutton"]');
        
        // Attach the stopChange function as an event listener to each number input
        numberInputs.forEach((input) => {
            input.addEventListener('wheel', stopChange);
            input.addEventListener('keydown', stopChange);
            input.addEventListener('keyup', stopChange);
        });
        spinButtonInputs.forEach((input) => {
            input.addEventListener('wheel', stopChange);
            input.addEventListener('keydown', stopChange);
            input.addEventListener('keyup', stopChange);
        });
            
        // Clean up by removing the event listeners when the component unmounts
        return () => {
            numberInputs.forEach((input) => {
                input.removeEventListener('wheel', stopChange);
                input.removeEventListener('keydown', stopChange);
                input.removeEventListener('keyup', stopChange);
            });
            spinButtonInputs.forEach((input) => {
                input.removeEventListener('wheel', stopChange);
                input.removeEventListener('keydown', stopChange);
                input.removeEventListener('keyup', stopChange);
            });
            };
    }, []); // The empty dependency array ensures that this effect runs once, like componentDidMount
};

export default useDisableNumberInputScroll;